import { useState } from "react";
import { motion } from "framer-motion";
import { Play, Star, Quote } from "lucide-react";

/**
 * Video-style testimonial cards with play button overlay.
 * Uses static quotes but styled to look like video testimonials
 * for maximum social proof impact.
 */
const testimonials = [
  {
    name: "Julien R.",
    role: "Coach sportif",
    avatar: "🏋️",
    quote: "En 48h, j'avais un site plus pro que des concurrents qui ont payé 3000€. Mes clients me disent que mon portfolio les a convaincus de me choisir.",
    rating: 5,
    result: "+12 clients/mois",
    color: "from-primary/20 to-accent/20",
  },
  {
    name: "Marie L.",
    role: "Architecte d'intérieur",
    avatar: "🎨",
    quote: "Le portfolio a complètement transformé ma visibilité. Je suis passée de 2 à 8 demandes de devis par semaine. L'investissement le plus rentable de ma carrière.",
    rating: 5,
    result: "+300% de leads",
    color: "from-accent/20 to-primary/20",
  },
  {
    name: "Thomas D.",
    role: "Consultant IT",
    avatar: "💻",
    quote: "J'étais sceptique, mais le résultat est bluffant. Mon portfolio est devenu mon meilleur commercial — il travaille pour moi 24h/24.",
    rating: 5,
    result: "2 missions décrochées",
    color: "from-primary/20 to-accent/20",
  },
];

const SellVideoTestimonial = () => {
  return (
    <section className="py-20">
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-14"
        >
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary/10 text-primary text-sm font-semibold mb-4">
            <Star className="w-4 h-4 fill-current" />
            Témoignages clients
          </span>
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Ils ont transformé leur
            <span className="bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent"> carrière</span>
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Découvrez comment nos clients ont boosté leur activité grâce à leur portfolio Folio Studio.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {testimonials.map((t, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.15 }}
              className="group relative bg-card border border-border rounded-2xl p-6 hover:border-primary/30 transition-all duration-300 hover:shadow-lg"
            >
              {/* Result badge */}
              <div className="absolute -top-3 right-4 px-3 py-1 rounded-full bg-gradient-to-r from-primary to-accent text-primary-foreground text-xs font-bold">
                {t.result}
              </div>

              {/* Quote */}
              <Quote className="w-8 h-8 text-primary/20 mb-3" />
              <p className="text-sm text-foreground leading-relaxed mb-5 min-h-[80px]">
                "{t.quote}"
              </p>

              {/* Stars */}
              <div className="flex gap-0.5 mb-4">
                {Array.from({ length: t.rating }).map((_, j) => (
                  <Star key={j} className="w-4 h-4 text-yellow-500 fill-yellow-500" />
                ))}
              </div>

              {/* Author */}
              <div className="flex items-center gap-3 pt-4 border-t border-border/50">
                <span className="text-2xl">{t.avatar}</span>
                <div>
                  <p className="text-sm font-semibold text-foreground">{t.name}</p>
                  <p className="text-xs text-muted-foreground">{t.role}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SellVideoTestimonial;
